import {Injectable, Renderer2, RendererFactory2, EventEmitter} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ThemeService {
  private renderer: Renderer2;
  private currentTheme: 'light' | 'dark' = 'light'; // Default to light
  public themeChanged: EventEmitter<'light' | 'dark'> = new EventEmitter<'light' | 'dark'>();

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setTheme(theme: 'light' | 'dark'): void {
    this.currentTheme = theme;
    // Imposta l'attributo sul tag html per l'app normale
    this.renderer.setAttribute(document.documentElement, 'data-bs-theme', theme);
    localStorage.setItem('user-theme', theme);

    // Notifica tutti i componenti in ascolto (incluso il web component)
    this.themeChanged.emit(theme);
  }

  initTheme(): void {
    const savedTheme = localStorage.getItem('user-theme') as 'light' | 'dark';
    // Se non c'è un tema salvato, usa 'light' come default
    const themeToApply = savedTheme || 'light';
    this.setTheme(themeToApply);
  }

  getTheme(): 'light' | 'dark' {
    return this.currentTheme;
  }
}





